import React from 'react'
import classNames from 'classnames'
import styles from './DifficultyRating.module.css'
import { DifficultyRatingProps } from './DifficultyRating.types'

const DifficultyRating = ({
  difficulty,
  className,
  onClick,
}: DifficultyRatingProps) => {
  const rating = {
    beginner: 1,
    intermediate: 2,
    advanced: 3,
  }

  const selectRating = (value: number) => {
    if (onClick) {
      onClick(value)
    }
  }

  const isButton = () => {
    return onClick ? 'cursor-pointer' : 'cursor-default'
  }

  return (
    <div className={classNames(styles.root, className)}>
      <div className={classNames(styles.difficultyWrapper, 'flex', 'gap-2')}>
        <button
          type='button'
          onClick={() => {
            selectRating(rating.beginner)
          }}
          className={classNames(
            styles.difficultyMarker,
            'rounded-l',
            isButton(),
            difficulty >= rating.beginner && styles.active
          )}
        />
        <button
          type='button'
          onClick={() => {
            selectRating(rating.intermediate)
          }}
          className={classNames(
            styles.difficultyMarker,
            isButton(),
            difficulty >= rating.intermediate && styles.active
          )}
        />
        <button
          type='button'
          onClick={() => {
            selectRating(rating.advanced)
          }}
          className={classNames(
            styles.difficultyMarker,
            'rounded-r',
            isButton(),
            difficulty >= rating.advanced && styles.active
          )}
        />
      </div>
    </div>
  )
}

export default DifficultyRating
